module.exports = __webpack_public_path__ + "img/arrow-right.aa8f607b.svg";